import React from "react";
import { Container } from "reactstrap";
import Agenda from "./Agenda";

// My Bookings: agenda del giorno e della settimana.
const Bookings = () => (
  <div className="content">
    <Container fluid>
      <Agenda />
    </Container>
  </div>
);

export default Bookings;
